import { Application } from '../api/application';

export const goToApplication = (application: Application) => {
    document.location.href = application.url;
}
